import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getWorkspace, Workspace } from '../../api/WorkspaceService';
import { StoreState } from '../../store/store';

export const fetchWorkspaceData = createAsyncThunk<
  Workspace,
  string,
  { state: StoreState }
>('workspace/fetchWorkspaceData', async workspaceUUID => {
  const data = await getWorkspace(workspaceUUID);
  return data;
});

export interface WorkspaceState {
  uuid: string;
  name: string;
}

const initialState: WorkspaceState = {
  uuid: '',
  name: '',
};

export const workspaceNameSelector = (state: StoreState) =>
  state.workspace.name;

const { reducer } = createSlice({
  name: 'workspace',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchWorkspaceData.pending, state => ({
      ...state,
      uuid: '',
      name: '',
    }));
    builder.addCase(fetchWorkspaceData.rejected, state => ({
      ...state,
      uuid: '',
      name: '',
    }));
    builder.addCase(fetchWorkspaceData.fulfilled, (state, action) => ({
      ...state,
      uuid: action.payload.objectUUID,
      name: action.payload.name,
    }));
  },
});

export default reducer;
